/*****************************************************/
/* 処　理：SMS004 コンビニ収納サービス 画面
/*
/* 概　要：定数定義
/*
/* 更新日：2025/01/08 HARAGU 00011_SMS機能等の導入支援
/*****************************************************/

// 処理名
export const INIT_NAME = '初期表示';
export const BARCODE_NAME = 'バーコード生成';
export const BTN_BARCODE_NAME = 'コンビニ払いバーコード発行';
export const BTN_DETAIL_NAME = '詳細金額表示へ';
export const BTN_BACKMENU_NAME = 'メニューへ戻る';

// APIパス
export const API_INIT_PATH = '/SMS004/init';
export const API_BARCODE_PATH = '/SMS004/barcode';

// 請求金額上限
export const LIMIT_SEIKYU_KINGAKU = 300000;
